import { pipe, append, join, __ } from 'ramda'
import { useTranslation, UseTranslationOptions } from 'react-i18next'

/**
 * @deprecated
 * This feels like unnecessary complication. I would just use the `t` function directly.
 */
// eslint-disable-next-line import/no-unused-modules
export const useTranslationSection = (
  section: string,
  options?: UseTranslationOptions,
) => {
  const { t } = useTranslation()

  if (options) return t(section, options)

  return pipe(append(__, [section]), join('.'), t)
}
